export async function finalizarJogoDoDia(idDiaDeJogo) {
    const response = await fetch(`/api/DiasDeJogo/${idDiaDeJogo}/Finalizar`, {
        method: 'POST'
    });

    if (!response.ok) {
        const msg = await response.text();
        throw new Error(msg || 'Erro ao salvar resultado');
    }
}

export async function excluirDiaDeJogo(idDiaDeJogo) {
    const response = await fetch(`/api/DiasDeJogo/${idDiaDeJogo}`, {
        method: 'DELETE'
    });

    if (!response.ok) {
        const msg = await response.text();
        throw new Error(msg || 'Erro ao excluir dia de jogo');
    }
}